export const MANU_SUBTITLE =
    "Enter the manufacturer of the device you would like to register"
